import { styled } from 'next-yak';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import { scale060, scale110 } from '@xing-com/tokens';

import { SkeletonCircle, SkeletonRectangle } from '../';

// *** Components ***
const ContainerElement = createPolymorphicElement('div');

export const Container = styled(ContainerElement)`
  align-items: center;
  display: flex;
  height: ${scale110};
  position: relative;
  width: 100%;
`;

export const Slider = styled(SkeletonRectangle)`
  margin-inline-start: ${scale060};
`;

export const Handle = styled(SkeletonCircle)`
  inset-inline-start: 20%;
  position: absolute;
`;
